import streamDestinations from './destinations'
import streamSource from './source'
import QamonGetWebsitesForSelectedCompanySelectorCreator from './qmon_websites_for_selected_company'


export const makeStreamSource = streamSource
export const makeStreamDestinations = streamDestinations
export const QamonGetWebsitesForSelectedCompany = QamonGetWebsitesForSelectedCompanySelectorCreator
